'use strict';
function Controller($location, $rootScope) {
	let deregisterLocationChange;

	this.$onInit = () => {
		this.defaultKey = this.active;

		if (this.stateParam) {
			this.active = $location.search()[this.stateParam] || this.active;

			deregisterLocationChange = $rootScope.$on('$locationChangeSuccess', () => {
				this.active = $location.search()[this.stateParam] || this.defaultKey;
			});
		}
	};

	this.$onDestroy = () => {
		if (this.stateParam) {
			$location.search(this.stateParam, null);
			deregisterLocationChange();
		}
	};

	this.setActive = key => {
		if (this.stateParam) {
			$location.search(this.stateParam, key !== this.defaultKey ? key : null);
		}
		this.active = key;

		if (this.onChange) {
			this.onChange(key);
		}
	};
}
angular.module('PinMeTo.UI').component('pmtFilters', {
	templateUrl: 'pmtShared/pmtUi/Filters.html',
	controller: Controller,
	bindings: {
		stateParam: '@',
		filters: '<',
		active: '=',
		onChange: '<'
	}
});

Controller.$inject = ['$location', '$rootScope'];
